import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div>
      <h1 className="mb-3 text-2xl font-bold text-green-700">Page not found</h1>
      <p className="m-0">
        <Link
          to="/"
          className="font-medium text-blue-500 no-underline hover:underline"
        >
          Back to the Hub
        </Link>
      </p>
    </div>
  );
}
